// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1u4Ap","requiredAsterisk":"Info_requiredAsterisk__1fdVQ"};